import { Link, useSearchParams } from 'react-router-dom'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { ContentCard } from '../components/ContentCard'
import { SearchBox } from '../components/SearchBox'
import { searchArticles } from '../data/articles'
import { searchContents } from '../data/content'
import { DEITIES } from '../data/deities'
import { useSeo } from '../hooks/useSeo'

export function SearchPage() {
  const [params] = useSearchParams()
  const q = params.get('q') ?? ''
  const contents = searchContents(q)
  const articles = searchArticles(q)
  const deities = DEITIES.filter(
    (d) =>
      d.nameTa.toLowerCase().includes(q.toLowerCase()) ||
      d.nameEn.toLowerCase().includes(q.toLowerCase()),
  )

  useSeo({ title: q ? `தேடல்: ${q}` : 'தேடல்', path: '/search' })

  return (
    <div className="container section">
      <Breadcrumbs items={[{ label: 'முகப்பு', to: '/' }, { label: 'தேடல்' }]} />
      <div className="section-header">
        <h1>தேடல்</h1>
        <SearchBox initialQuery={q} />
      </div>

      {!q && <p className="empty-state">தமிழ் அல்லது ஆங்கிலத்தில் தேடுங்கள் — எ.கா. லிங்காஷ்டகம், Murugan, ஆடி வெள்ளி</p>}

      {q && contents.length === 0 && articles.length === 0 && deities.length === 0 && (
        <p className="empty-state">«{q}» க்கு முடிவுகள் இல்லை. வேறு சொல் முயற்சிக்கவும்.</p>
      )}

      {deities.length > 0 && (
        <section className="section--tight">
          <h2>தெய்வங்கள்</h2>
          <div className="card-grid">
            {deities.map((d) => (
              <Link key={d.id} to={`/deities/${d.id}`} className="content-card">
                <h3>{d.nameTa}</h3>
                <span className="content-card__en">{d.nameEn}</span>
                <p>{d.descriptionTa}</p>
              </Link>
            ))}
          </div>
        </section>
      )}

      {contents.length > 0 && (
        <section className="section--tight">
          <h2>பாடல்கள் & ஸ்துதிகள்</h2>
          <div className="card-grid card-grid--3">
            {contents.map((item) => (
              <ContentCard key={item.id} item={item} />
            ))}
          </div>
        </section>
      )}

      {articles.length > 0 && (
        <section className="section--tight">
          <h2>கட்டுரைகள்</h2>
          <div className="card-grid card-grid--3">
            {articles.map((a) => (
              <Link key={a.id} to={`/spiritual/${a.slug}`} className="content-card">
                <h3>{a.titleTa}</h3>
                <p>{a.excerptTa}</p>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  )
}
